<template>
  <div class="grid-view">
    <div class="main-content">
      <!--按钮-->
      <div style="margin-top: 5px">
        <el-button type="primary" no="back" @click="$emit('back')">{{ $t('common.btn.back') }}</el-button>
        <el-button type="primary" no="planIssued" :disabled="infoCostIsEdit || form.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_SAVED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_ISSUE.code)">{{ $t('CargoMsg.Cargo_PlanIssued') }}</el-button>
        <el-button type="primary" no="cancelPlanIssued" :disabled="infoCostIsEdit || form.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_ISSUED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_ISSUE.code)">{{ $t('CargoMsg.Cargo_CancelPlanIssued') }}</el-button>
        <el-button type="primary" no="assemblyCompleted" :disabled="infoCostIsEdit || form.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_ISSUED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_COMPLETE.code)">{{ $t('CargoMsg.Cargo_AssemblyCompleted') }}</el-button>
        <el-button type="primary" no="cancelAssemblyCompleted" :disabled="infoCostIsEdit || form.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_COMPLETED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_COMPLETE.code)">{{ $t('CargoMsg.Cargo_CancelAssemblyCompleted') }}</el-button>
        <!--确认完成 无限制，不需要设置disabled-->
        <el-button type="primary" no="confirmCompleted" :disabled="infoCostIsEdit || form.status === SystemConstants.ASSEMBLY_PLAN_STATUS_CONFIRMED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_CONFIRM.code)">{{ $t('CargoMsg.Cargo_ConfirmCompleted') }}</el-button>
        <el-button type="primary" no="cancelConfirmCompleted" :disabled="infoCostIsEdit || form.status !== SystemConstants.ASSEMBLY_PLAN_STATUS_CONFIRMED.code" @click="editStatus(SystemConstants.ASSEMBLY_PLAN_ACTION_CANCEL_CONFIRM.code)">{{ $t('CargoMsg.Cargo_CancelConfirmCompleted') }}</el-button>
        <!--计划打印 下达及之后的状态可以打印-->
        <el-button type="primary" no="planPrint" :disabled="infoCostIsEdit || editable" @click="toPrint">{{ $t('CargoMsg.Cargo_PlanPrint') }}</el-button>
        <!--导入 集装器-业务-->
        <el-button type="primary" no="importAssemblyPlan" :disabled="infoCostIsEdit || !editable" @click="importVisible=true">{{ $t('CargoMsg.Cargo_ImportAssemblyPlan') }}</el-button>
        <el-button type="primary" no="loadPoolDrawerVisible" :disabled="infoCostIsEdit || !editable" @click="openLoadPool">{{ $t('CargoMsg.Cargo_LoadingPool') }}</el-button>
        <el-button type="primary" no="mergeUlds" :disabled="infoCostIsEdit || !editable" @click="mergeUlds">{{ $t('CargoMsg.Cargo_MergeGroup') }}</el-button>
        <el-button type="primary" no="delUlds" :disabled="infoCostIsEdit || !editable" @click="delUlds">{{ $t('CargoMsg.Cargo_DeleteGroup') }}</el-button>
        <span no="status" style="font-size:14px;color:red">
          {{ ColumnUtils.showTypeLabelFunc(form.status, SystemConstants.ASSEMBLY_PLAN_STATUS) }}
        </span>
      </div>
      <!--计划基本信息-->
      <assembly-plan-info
        ref="assemblyPlanInfo"
        :origin-form="form"
        :airline-product-down-list="airlineProductDownList"
        :editable="editable"
        :assembly-plan-cost-is-edit="assemblyPlanCostIsEdit"
        @saveAssemblyPlanSuccess="saveAssemblyPlanSuccess"
        @isEdit="p => assemblyPlanInfoIsEdit = p"
      />
      <!--计划统计信息-->
      <span style="margin-top: 5px">{{ $t('SeaExport.OrderNumber') + ': ' + form.itemsCount + ', ' + $t('CargoMsg.Cargo_PieceWeightVolumeUnit') + ': '
        + form.quantityAssembly + '/' + form.weightAssembly + '/' + form.cubageAssembly + '/' + form.chargeWeightAssembly }}</span>
      <el-tabs v-model="activeName" style="height: 100%" type="card" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_Basic')" name="planContent">
          <!--计划-集装器、计划-集装器-业务-->
          <div class="section grid-wrapper">
            <cargo-ag-grid-wrapper
              config-module="202206073"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="form.list"
              :show-selected-color="false"
              :check-sub-record="false"
              style="height: 100%;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_PrimeCost')" name="assemblyPlanCost">
          <assembly-plan-cost
            ref="assemblyPlanCost"
            :form="form"
            :editable="editable"
            :assembly-plan-info-is-edit="assemblyPlanInfoIsEdit"
            @isEdit="p => assemblyPlanCostIsEdit = p"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_FileHistory')" name="tabFileHistory" :lazy="true" style="height: 509px;">
          <tab-file-history ref="tabFileHistory" :context="context" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--配载池-->
    <load-pool-drawer :airline-product-down-list="airlineProductDownList" :visible.sync="loadPoolDrawerVisible" @addUldItemsToUld="addUldItemsToUld" />
    <!--拼装计划弹窗（编辑计划基本信息）-->
    <!--    <assembly-plan-dialog-->
    <!--      v-if="assemblyPlanDialog.visible"-->
    <!--      :visible.sync="assemblyPlanDialog.visible"-->
    <!--      :form="assemblyPlanDialog.form"-->
    <!--      :airline-product-down-list="airlineProductDownList"-->
    <!--      @saveAssemblyPlanSuccess="detailAndRefreshTab"-->
    <!--    />-->
    <!--集装器弹窗（编辑集装器信息）-->
    <el-dialog
      v-if="assemblyPlanUldDialog.visible"
      v-el-drag-dialog
      :visible.sync="assemblyPlanUldDialog.visible"
      :title="assemblyPlanUldDialog.title"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form style="display: flex;flex-wrap: wrap" :label-width="$selectByLang('100px', '140px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_NameP')" required>
          <el-input v-model="assemblyPlanUldDialog.form.name" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="editUld">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="assemblyPlanUldDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--导入 集装器-业务 弹窗-->
    <import-dialog
      :title="$t('CargoMsg.Cargo_ImportAssemblyPlan')"
      :action="URL.booking.airExport.importUldAndJob"
      :visible="importVisible"
      :params="{ assemblyPlanUuid }"
      :error-tip-detail="true"
      folder-name="booking"
      file-name="AssemblyPlanImport.xlsx"
      @uploadSuccess="detail"
      @onClose="importVisible=false"
    />
    <!--拼装计划 打印 弹窗-->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  DATA_TYPE_LEVEL_1,
  DATA_TYPE_LEVEL_2
} from '@/class/cargo/model/parameters/SystemConstants'
import airlineProductVoyage from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage'
import airlineProductVoyageCost from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { AssemblyPlanUld } from '@/class/model/booking/AssemblyPlanUld'
import { deepClone, getUuid } from '@/utils'
import {
  assemblyHandle,
  editAssemblyPlanStatus,
  queryAssemblyPlanDetail
} from '@/api/booking/assemblyPlan'
import { AssemblyPlan } from '@/class/model/booking/AssemblyPlan'
import loadPoolDrawer from '@/views/cargo/v0/AirExport/components/loadManagement/loadPoolDrawer'
import { DocumentManage } from '@/utils/commonUtil'
import assemblyPlanInfo from '@/views/cargo/v0/AirExport/components/loadManagement/assemblyPlanInfo'
import assemblyPlanCost from '@/views/cargo/v0/AirExport/components/loadManagement/assemblyPlanCost'
import ImportDialog from '@/views/cargo/v0/Information/components/basicData/importDialog.vue'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import $store from '@/store'
import { cache, cacheName } from '@/utils/cacheManager'
import URL from '@/api/urlTranslator'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import AssemblyPlanUtils from '@/utils/AssemblyPlanUtils'

export default {
  name: 'AssemblyPlanDetail',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, ImportDialog, AutoNumberInput,
    cargoInputNumber, cargoNumericStepper, airlineProductVoyage, airlineProductVoyageCost, loadPoolDrawer, assemblyPlanInfo,
    cargoTemplateSelectorDialog, assemblyPlanCost, tabFileHistory },
  props: {
    assemblyPlanUuid: { type: String, default: '' },
    airlineProductDownList: { type: Array, default: () => [] }
  },
  data() {
    return {
      AutoComplete,
      context: new BookingWorkspaceContext(),
      URL, ColumnUtils,
      form: {
        itemsCount: 0,
        quantityAssembly: 0,
        weightAssembly: 0,
        cubageAssembly: 0,
        chargeWeightAssembly: 0
      },
      documentManage: new DocumentManage(),
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        suppressMoveWhenRowDragging: true, // 如果为true，则在拖动行时不会移动行。这意味着您可以拖动行，而不会影响行的顺序。
        enableCellTextSelection: false, // 禁止文本选中
        rowMultiSelectWithClick: false, // 禁止点击行触发多选
        suppressClickEdit: true, // 添加这个确保点击行不会改变选择状态
        groupSelectsChildren: false, // 禁用父子联动选中
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          if (data.path) {
            return data.path.split(',')
          }
          return ''
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_ContainerGroup'),
          colId: 'name',
          field: 'name',
          width: 160,
          rowDrag: params => params.data && params.data.hasOwnProperty('dataType') && Number(params.data.dataType) === DATA_TYPE_LEVEL_2.code, // 集装器不可拖动
          headerCheckboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const data = params.data
              if (params.data && data.hasOwnProperty('dataType') && Number(data.dataType) === DATA_TYPE_LEVEL_1.code) {
                return true
              }
              return false
            },
            innerRenderer: params => {
              const data = params.data
              if (params.data && data.hasOwnProperty('dataType') && Number(data.dataType) === DATA_TYPE_LEVEL_1.code) {
                const showEditUldDialog = this.documentManage.getPath('showEditUldDialog')
                return `<div>
                          <div>${params.data.name}</div>
                          <button style="border-radius: 2px;position: absolute;right: 20px;top: 4px" onclick="${showEditUldDialog}('${params.data.uuid}')">
                              <i class="el-icon-edit">
                              </i>
                          </button>
                        </div>`
              }
              return ''
            }
          },
          tooltip: params => {
            return params.data.code
          },
          suppressMenu: true,
          pinned: 'left'
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // onRowClicked: event => { this.selectedRow = event.data },
        onRowDragEnd: this.onRowDragEnd, // 拖动结束
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 140,
          cellRenderer: params => {
            if (params.data.dataType === DATA_TYPE_LEVEL_1.code) {
              const addUld = this.documentManage.getPath('addUld')
              return `<div>
                        <a onclick="${addUld}()" style="color:#1F75D5;font-size:25px;">+</a>
                      </div>`
            }
            const delUldItemFromUld = this.documentManage.getPath('delUldItemFromUld')
            return `<div>
                        <a onclick="${delUldItemFromUld}('${params.data.uuid}')" style="color:#1F75D5;font-size:25px;">-</a>
                     </div>`
          },
          pinned: 'left'
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          field: 'portOfDeparture',
          colId: 'portOfDeparture',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          width: 100
        }, {
          headerName: this.$t('SeaExport.MasterBillNo'),
          field: 'mbl',
          colId: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SeparateNumber'),
          field: 'hawb',
          colId: 'hawb',
          width: 100
        }, {
          headerName: this.$t('SeaExport.OrderNo2'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 180
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyItemCount'),
          field: 'quantityAssembly',
          colId: 'quantityAssembly',
          width: 180,
          cellRenderer: params => {
            if (params.data.dataType === DATA_TYPE_LEVEL_1.code) {
              return ''
            }
            return ColumnUtils.getAssemblyInfoLabel(params.data.quantityAssembly, params.data.quantity, params.data.totalQuantityAssembly)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyGrossWeight'),
          field: 'weightAssembly',
          colId: 'weightAssembly',
          width: 180,
          cellRenderer: params => {
            if (params.data.dataType === DATA_TYPE_LEVEL_1.code) {
              return ''
            }
            return ColumnUtils.getAssemblyInfoLabel(params.data.weightAssembly, params.data.weight, params.data.totalWeightAssembly)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyVolume'),
          field: 'cubageAssembly',
          colId: 'cubageAssembly',
          width: 180,
          cellRenderer: params => {
            if (params.data.dataType === DATA_TYPE_LEVEL_1.code) {
              return ''
            }
            return ColumnUtils.getAssemblyInfoLabel(params.data.cubageAssembly, params.data.cubage, params.data.totalCubageAssembly)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AssemblyChargeableWeight'),
          field: 'chargeWeightAssembly',
          colId: 'chargeWeightAssembly',
          width: 180,
          cellRenderer: params => {
            if (params.data.dataType === DATA_TYPE_LEVEL_1.code) {
              return ''
            }
            return ColumnUtils.getAssemblyInfoLabel(params.data.chargeWeightAssembly, params.data.chargeWeight, params.data.totalChargeWeightAssembly)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Density_Weight'),
          field: 'density',
          colId: 'density',
          width: 100,
          cellRenderer: params => {
            return params.value ? ColumnUtils.number3ColumnLabelFunc(params.value) : ''
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Customer'), field: 'customerId', width: 180, colId: 'customerId',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.Sales'), field: 'sales', width: 180, colId: 'sales',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_sales') : ''
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.CustomerService'), field: 'csr', width: 180, colId: 'csr',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_csr') : ''
          },
          hide: true
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 180, colId: 'op',
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'auto_op') : ''
          },
          hide: true
        }
      ],
      // rowData: [],
      selectedRows: [],
      gridApi: null,
      // isView: true,
      loadPoolDrawerVisible: false,
      params: { // 按钮 操作的参数
        assemblyPlanUuid: this.assemblyPlanUuid,
        assemblyPlan: null,
        assemblyPlanUld: null,
        assemblyPlanUldItems: [],
        delAssemblyPlanUldKeys: [],
        delAssemblyPlanUldItemKeys: []
      },
      isExpanded: true, // 是否 展开
      isEdit: true, // 是否 编辑
      // assemblyPlanDialog: {
      //   visible: false,
      //   form: new AssemblyPlan().fillDefaultValue().getData()
      // },
      assemblyPlanUldDialog: {
        visible: false,
        form: new AssemblyPlanUld().fillDefaultValue().getData(),
        title: this.$t('CargoMsg.Cargo_Edit') + this.$t('CargoMsg.Cargo_ContainerGroup')
      },
      importVisible: false,
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'ASSEMBLY_PLAN',
        data: {
          ASSEMBLY_PLAN_UUID: ''
        }
      },
      assemblyPlanAllocateCostToJob: false, // 是否分摊费用
      activeName: 'planContent',
      assemblyPlanInfoIsEdit: false, // 三个区域的按钮 不能同时可操作
      assemblyPlanCostIsEdit: false // 三个区域的按钮 不能同时可操作
    }
  },
  computed: {
    editable() {
      return this.form.status === SystemConstants.ASSEMBLY_PLAN_STATUS_SAVED.code
    },
    infoCostIsEdit() {
      return this.assemblyPlanInfoIsEdit || this.assemblyPlanCostIsEdit
    }
  },
  watch: {
    assemblyPlanUuid() {
      this.detail()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('addUld', function(uid) {
      context.addUld(uid)
    })
    this.documentManage.set('delUldItemFromUld', function(uid) {
      context.delUldItemFromUld(uid)
    })
    this.documentManage.set('showEditUldDialog', function(uid) {
      context.showEditUldDialog(uid)
    })
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.assemblyPlanAllocateCostToJob = parseInt(cache.config.get('AssemblyPlanAllocateCostToJob')) === 1
    this.detail()
  },
  methods: {
    // 打印按钮触发事件
    toPrint() {
      this.templateSelectorDialog.data.ASSEMBLY_PLAN_UUID = this.assemblyPlanUuid
      this.templateSelectorDialog.visible = true
    },
    // 编辑 拼装计划状态
    async editStatus(action) {
      // 提示：已经分摊过成本，请用户自行删除已分摊的成本，是否继续？
      if (SystemConstants.ASSEMBLY_PLAN_ACTION_CONFIRM.code === action && this.assemblyPlanAllocateCostToJob) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_CostAllocated'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      this.loading = getLoading4Cxt()
      editAssemblyPlanStatus({
        assemblyPlan: { uuid: this.form.uuid, version: this.form.version, branchId: this.$store.getters.currentOfficeId },
        action,
        branchId: $store.getters.currentOfficeId
      }).then(res => {
        this.detail()
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 显示 编辑集装器
    async editUld() {
      if (!this.assemblyPlanUldDialog.form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_Name'))
        return
      }
      this.resetParams()
      this.params.assemblyPlanUld = this.assemblyPlanUldDialog.form
      this.params.assemblyPlanUld.assemblyPlanUldItems = [] // 解决json解析问题
      await this.assemblyHandle(true)
      // const uld = this.form.list.find(p => p.uuid === this.assemblyPlanUldDialog.form.uuid)
      // Object.assign(uld, this.assemblyPlanUldDialog.form)
      this.gridApi.refreshCells({ force: true })
      this.assemblyPlanUldDialog.visible = false
    },
    // 显示 编辑集装器弹窗
    showEditUldDialog(uuid) {
      if (!this.editable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlanIssuedTip'))
        return
      }
      const uld = this.form.list.find(p => p.uuid === uuid)
      this.assemblyPlanUldDialog.form = deepClone(uld)
      this.assemblyPlanUldDialog.visible = true
    },
    resetParams() {
      this.params = {
        assemblyPlanUuid: this.assemblyPlanUuid,
        assemblyPlan: null,
        assemblyPlanUld: null,
        assemblyPlanUldItems: [],
        delAssemblyPlanUldKeys: [],
        delAssemblyPlanUldItemKeys: []
      }
    },
    // 新增 集装器
    async addUld() {
      if (!this.editable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlanIssuedTip'))
        return
      }
      const productVoyage = AssemblyPlanUtils.getProductVoyage(this.airlineProductDownList, this.form)
      const ulds = this.form.list.filter(p => p.dataType === DATA_TYPE_LEVEL_1.code)
      // 根据 【航线产品】 带出
      if (productVoyage && productVoyage.voyageBoards && ulds && ulds.length > productVoyage.voyageBoards.length) {
        const flag = await this.$confirm(this.$t('CargoMsg.Cargo_AssemblyPlanExceedsContainerGroup'), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (!flag) {
          return
        }
      }
      this.resetParams()
      const assemblyPlanUld = new AssemblyPlanUld().fillDefaultValue().getData()
      assemblyPlanUld.path = getUuid()
      assemblyPlanUld.assemblyPlanUuid = this.assemblyPlanUuid
      // this.form.list.push(assemblyPlanUld)
      this.params.assemblyPlanUld = assemblyPlanUld
      this.assemblyHandle(true)
    },
    // 删除 集装器
    async delUlds() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const ulds = this.form.list.filter(p => p.dataType === DATA_TYPE_LEVEL_1.code)
      if (this.selectedRows.length === ulds.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_MaintainAtLeastOneGroup'))
        return
      }
      const delAssemblyPlanUldKeys = this.selectedRows.map(p => p.uuid)
      const item = this.form.list.find(p => p.dataType === DATA_TYPE_LEVEL_2.code && delAssemblyPlanUldKeys.indexOf(p.assemblyPlanUldUuid) > -1)
      if (item) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContainerGroupHasOrder'))
        return
      }
      this.resetParams()
      this.params.delAssemblyPlanUldKeys = delAssemblyPlanUldKeys
      this.form.list.forEach(row => {
        if (this.params.delAssemblyPlanUldKeys.indexOf(row.assemblyPlanUldUuid) > -1) {
          this.params.delAssemblyPlanUldItemKeys.push(row.uuid)
        }
      })
      if (this.params.delAssemblyPlanUldItemKeys && this.params.delAssemblyPlanUldItemKeys.length > 0) {
        await this.assemblyHandle(true)
      } else {
        this.form.list = this.form.list.filter(p => this.params.delAssemblyPlanUldKeys.indexOf(p.uuid) === -1 && this.params.delAssemblyPlanUldKeys.indexOf(p.assemblyPlanUldUuid) === -1)
        await this.assemblyHandle(false)
      }
      this.selectedRows = []
    },
    // 合并 集装器
    async mergeUlds() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      this.resetParams()
      const uld = this.selectedRows[0]
      const uldItemMap = new Map()
      this.form.list.forEach(p => {
        if (p.dataType === DATA_TYPE_LEVEL_2.code && p.assemblyPlanUldUuid === uld.uuid) {
          uldItemMap.set(p.jobUuid, p)
        }
      })
      this.selectedRows.forEach(row => {
        if (row.uuid !== uld.uuid) {
          this.params.delAssemblyPlanUldKeys.push(row.uuid)
          const assemblyPlanUldItems = this.form.list.filter(p => p.dataType === DATA_TYPE_LEVEL_2.code && p.assemblyPlanUldUuid === row.uuid)
          if (assemblyPlanUldItems && assemblyPlanUldItems.length > 0) {
            assemblyPlanUldItems.forEach(uldItem => {
              if (uldItemMap.has(uldItem.jobUuid)) {
                const existUldItem = uldItemMap.get(uldItem.jobUuid)
                existUldItem.quantityAssembly = NumberUtils.ToFixed2(existUldItem.quantityAssembly + uldItem.quantityAssembly, 3)
                existUldItem.weightAssembly = NumberUtils.ToFixed2(existUldItem.weightAssembly + uldItem.weightAssembly, 3)
                existUldItem.cubageAssembly = NumberUtils.ToFixed2(existUldItem.cubageAssembly + uldItem.cubageAssembly, 3)
                existUldItem.chargeWeightAssembly = NumberUtils.ToFixed2(existUldItem.chargeWeightAssembly + uldItem.chargeWeightAssembly, 3)
                this.params.delAssemblyPlanUldItemKeys.push(uldItem.uuid)
                this.params.assemblyPlanUldItems.push(existUldItem)
              } else {
                uldItem.assemblyPlanUldUuid = uld.uuid
                uldItem.assemblyPlanUuid = uld.assemblyPlanUuid
                this.params.assemblyPlanUldItems.push(uldItem)
              }
            })
          }
        }
      })
      await this.assemblyHandle(true)
      this.selectedRows = []
    },
    // 从 集装器 移除 业务
    delUldItemFromUld(uuid) {
      if (!this.editable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlanIssuedTip'))
        return
      }
      this.resetParams()
      this.params.delAssemblyPlanUldItemKeys.push(uuid)
      // this.form.list = this.form.list.filter(p => p.uuid !== uuid)
      this.assemblyHandle(true)
    },
    openLoadPool() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ContainerGroup'))
        return
      } else if (this.selectedRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectContainerGroup'))
        return
      } else if (this.selectedRows[0].dataType !== DATA_TYPE_LEVEL_1.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ContainerGroup'))
      }
      this.selectedRow = this.selectedRows[0]
      this.loadPoolDrawerVisible = true
    },
    // 将 业务s 加入到集装器
    addUldItemsToUld(uldItems) {
      this.resetParams()
      // 待拼箱的信息 设置到 拼装信息中
      uldItems.forEach(uldItem => {
        uldItem.quantityAssembly = uldItem.quantityNotAssembly
        uldItem.weightAssembly = uldItem.weightNotAssembly
        uldItem.cubageAssembly = uldItem.cubageNotAssembly
        uldItem.chargeWeightAssembly = uldItem.chargeWeightNotAssembly
        this.addUldItemToUld(this.selectedRow, uldItem)
      })
      this.assemblyHandle(true)
    },
    // 将 业务 拖拽到集装器
    async onRowDragEnd(event) {
      if (!this.editable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlanIssuedTip'))
        return
      }
      const { overNode, node } = event // overNode: 目标行, node: 拖拽行
      const overData = overNode.data
      const data = node.data
      this.resetParams()
      // 只能拖拽到别的集装器下，其他情况不处理
      if (overData.dataType !== DATA_TYPE_LEVEL_1.code) {
        this.$message.warning(this.$t('CargoMsg.cargo_can_only_be_dragged_under_a_container'))
        return
      }
      // 需跨集装器拖动
      if (overData.uuid === data.assemblyPlanUldUuid) {
        this.$message.warning(this.$t('CargoMsg.cargo_requires_dragging_across_containers'))
        return
      }
      this.addUldItemToUld(overData, data)
      this.assemblyHandle(true)
    },
    // 将 业务 加入到 集装器
    addUldItemToUld(uld, uldItem) {
      // 修改 拖拽行 和 已存在行
      const existUldItem = this.form.list.find(p => p.dataType === DATA_TYPE_LEVEL_2.code &&
        p.assemblyPlanUldUuid === uld.uuid && p.jobUuid === uldItem.jobUuid)
      if (existUldItem) {
        this.params.delAssemblyPlanUldItemKeys.push(uldItem.uuid)
        existUldItem.quantityAssembly = NumberUtils.ToFixed2(existUldItem.quantityAssembly + uldItem.quantityAssembly, 3)
        existUldItem.weightAssembly = NumberUtils.ToFixed2(existUldItem.weightAssembly + uldItem.weightAssembly, 3)
        existUldItem.cubageAssembly = NumberUtils.ToFixed2(existUldItem.cubageAssembly + uldItem.cubageAssembly, 3)
        existUldItem.chargeWeightAssembly = NumberUtils.ToFixed2(existUldItem.chargeWeightAssembly + uldItem.chargeWeightAssembly, 3)
        // this.form.list = this.form.list.filter(p => p.uuid !== uldItem.uuid)
        this.params.assemblyPlanUldItems.push(existUldItem)
      } else {
        uldItem.assemblyPlanUldUuid = uld.uuid
        uldItem.assemblyPlanUuid = uld.assemblyPlanUuid
        uldItem.path = uldItem.assemblyPlanUldUuid + ',' + uldItem.uuid
        this.params.assemblyPlanUldItems.push(uldItem)
      }
    },
    // 按钮操作 拼装计划
    async assemblyHandle(refresh = false) {
      this.loading = getLoading4Cxt()
      await assemblyHandle(this.params).then(async res => {
        if (refresh) {
          await this.detail()
        }
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查看 拼装计划 详情
    async detail() {
      this.loading = getLoading4Cxt()
      await queryAssemblyPlanDetail({ uuid: this.assemblyPlanUuid, branchId: this.$store.getters.currentOfficeId }).then(res => {
        this.form = res.data
      }).finally(() => {
        this.loading.close()
      })
      this.handleTabClick()
    },
    setSelectValue(obj) {
      this.form[obj.key] = obj.value
    },
    handleTabClick() {
      this.$nextTick(() => {
        if (this.activeName === 'tabFileHistory') {
          this.$refs.tabFileHistory.onShow(new AssemblyPlan(this.form), true)
        } else if (this.activeName === 'assemblyPlanCost') {
          this.$refs.assemblyPlanCost.init()
        }
      })
    },
    saveAssemblyPlanSuccess(assemblyPlanUuid) {
      if (assemblyPlanUuid === this.assemblyPlanUuid) {
        this.detail()
      } else {
        this.$emit('saveAssemblyPlanSuccess', assemblyPlanUuid)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.assembly-plan-detail-form .lable-blue ::v-deep {
  .el-form-item__label {
    color: blue !important;
  }
}
.assembly-plan-detail-form .el-form-item {
  margin-left: 20px;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
